<template>
  <v-card class="mx-auto mb-2 card">
    <!-- <div
      v-if="card.type == 'Image'"
      class="card__inner"
      :style="{ backgroundImage: `url(${card.src})` }"
    ></div> -->

    <div v-if="card.type == 'Image'" class="card__inner">
      <Imgx :src="card.src" />
    </div>

    <div v-if="card.type == 'Word'" class="card__inner">
      <div class="card__inner__text">
        <h2>{{ card.title }}</h2>
      </div>
    </div>
    <v-card-subtitle class="mb-2 pb-0"
      ><h3>{{ card.type }}</h3>
      <p>{{ card.category }}</p></v-card-subtitle
    >
    <v-card-actions>
      <v-chip class="mr-2" :to="`${path}/show/${card.id}`">
        Show
      </v-chip>
      <v-chip class="mr-2" :to="`${path}/edit/${card.id}`">
        Edit
      </v-chip>
      <v-chip class="mr-2" @click="deleteItem(card.id)">
        Delete
      </v-chip>
    </v-card-actions>
  </v-card>
</template>

<script>
// @ is an alias to /src
import router from "@/router";
import { Imgx } from "@/components/core";
export default {
  name: "AdminCardTile",
  components: {
    Imgx,
  },
  props: {
    card: Object,
    path: String,
  },
  methods: {
    deleteItem(id) {
      this.$parent.collection
        .doc(id)
        .delete()
        .then(() => {
          router.push({
            name: this.returnRoute,
          });
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
  },
};
</script>
